<!--
 * @Description: 列表，关联表格插槽
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->

<template>
  <!-- 主属性 -->
  <template v-if="props.detailKey">
    <!-- 客户特殊处理--详情 -->

    <template v-if="props.entity == 2 && props.row.customerName">
      <div v-if="props.row.isDealt" class="custom-name-tag-width">
        <jw-link v-if="props.row?.customerName" @click.stop="toDetails" class="custom-name-tag-width-link">{{ props.row?.customerName }}</jw-link>
        <template v-else>-</template>
        <!-- </jw-tooltip> -->
        <jw-tag size="small" class="custom-name-tag-width-tag" v-if="userInfo?.orgId == huaYingOrdId" :color="props.row.isDealt == '出资一次' || props.row.isDealt == '出资多次' ? 'green' : 'pinkpurple'">{{ $t(props.row.isDealt) }}</jw-tag>
        <template v-else>
          <jw-tag size="small" class="custom-name-tag-width-tag" v-if="props.row.isDealt == '成交一次' || props.row.isDealt == '成交多次'" color="green">{{ $t(props.row.isDealt) }}</jw-tag>
        </template>
      </div>
      <template v-else>
        <jw-link v-if="props.row?.customerName" @click.stop="toDetails">{{ props.row?.customerName }}</jw-link>
        <template v-else>-</template>
      </template>
    </template>
    <jw-link @click.stop="toDetails" v-else-if="props.row?.[detailKey]">{{ props.row[detailKey] }}</jw-link>
    <template v-else>-</template>
  </template>
  <!------------------------------------ 公共部分 S------------------------------------>
  <!--线索、线索池、客户 跟进建议  -->
  <template v-if="props.slotsName == 'intentionality'">
    <xl-dot :title="props.row?.intentionality" :color="data.colors[props.row?.intentionality]" v-if="props.row?.intentionality">
      {{ props.row.intentionality }}
    </xl-dot>
    <template v-else>-</template>
  </template>
  <!--线索、线索池、客户 客户级别 -->
  <template v-if="props.slotsName == 'customerLevel'">
    <jw-tag bordered size="small" :color="props.row?.customerLevel === 'A类' ? 'cyan' : props.row?.customerLevel === 'B类' ? 'arcoblue' : props.row?.customerLevel === 'C类' ? 'pinkpurple' : 'gray'" v-if="props.row?.customerLevel">
      {{ props.row.customerLevel }}
    </jw-tag>
    <template v-else>-</template>
  </template>
  <!--线索、线索池 线索状态 -->
  <template v-if="props.slotsName == 'clueStatus'">
    <jw-tag size="small" v-if="props.row.clueStatus == '已转化'" color="green">{{ props.row.clueStatus }}</jw-tag>
    <jw-tag size="small" v-else-if="props.row.clueStatus == '已领取'" color="blue">{{ props.row.clueStatus }}</jw-tag>
    <jw-tag size="small" v-else color="orange">{{ props.row.clueStatus }}</jw-tag>
  </template>
  <!--线索、线索池 是否为重点客户 -->
  <template v-if="props.slotsName == 'isImportant'">
    <jw-tag v-if="props.row?.isImportant == '是'" color="magenta" size="small">{{ $t('重点') }}</jw-tag>
    <template v-else>-</template>
  </template>
  <!-- 关联工商信息-->
  <template v-if="props.slotsName == 'qccId'">
    <jw-tag size="small" :color="props.row.qccId ? 'green' : 'pink'">{{ props.row.qccId ? $t('是') : $t('否') }}</jw-tag>
  </template>
  <!-- 成交状态 -->
  <template v-if="props.slotsName == 'isDealt'">
    <template v-if="props.row.isDealt">
      <jw-tag size="small" class="custom-name-tag-width-tag" v-if="userInfo?.orgId == huaYingOrdId" :color="props.row.isDealt == '出资一次' || props.row.isDealt == '出资多次' ? 'green' : 'pinkpurple'">{{ $t(props.row.isDealt) }}</jw-tag>
      <jw-tag size="small" class="custom-name-tag-width-tag" v-else :color="props.row.isDealt == '成交一次' || props.row.isDealt == '成交多次' ? 'green' : 'pinkpurple'">{{ $t(props.row.isDealt) }}</jw-tag>
    </template>
    <template v-else> - </template>
  </template>
  <!-- 重点客户插槽 -->
  <template v-if="props.slotsName == 'important'">
    <jw-tag size="small" v-if="props.row?.important" color="magenta">{{ $t('重点') }}</jw-tag>
    <template v-else>-</template>
  </template>
  <!-- 最后跟进内容 -->
  <template v-if="props.slotsName == 'lastFollowContent'">
    <template v-if="props.row?.lastFollowContent">{{ tools.handleRichText(props.row?.lastFollowContent) }}</template>
    <template v-else>-</template>
  </template>
  <!-- 报价单/销售订单  金额 -->
  <template v-if="props.slotsName == 'amount'">
    {{ tools.getPriceShow(props.row?.amount, props.row?.fieldExt) || '-' }}
  </template>
  <!-- 是否已经存在主合同 -->
  <template v-if="props.slotsName == 'isExistContract'">
    <jw-tag size="small" v-if="props.row.isExistContract == '1'" color="green">是</jw-tag>
    <jw-tag size="small" v-else-if="props.row.isExistContract == '0'" color="gold">否</jw-tag>
    <span v-else>-</span>
  </template>
  <!-- 飞书合同 -->
  <template v-if="props.slotsName == 'fsContractId'">
    <template v-if="props.entity === 10">
      <jw-link @click="openFSDetails(props.row)" v-if="props.row?.fieldList?.filter((v) => v.fieldKey === 'fs_contract_code')[0]?.fieldValue">{{ props.row?.fieldList?.filter((v) => v.fieldKey === 'fs_contract_code')[0]?.fieldValue }}</jw-link>
      <template v-else>-</template>
    </template>
    <template v-else>
      <!-- 2024/05/17 下午14:19，柳沛让前端拼接跳转路径 -->
      <template v-if="props.row?.fsContractId">
        <jw-link @click.stop="" v-if="tools.isJSON(props.row.fsContractMultiUrl) && JSON.parse(props.row.fsContractMultiUrl)?.pc_url" :href="JSON.parse(props.row.fsContractMultiUrl)?.pc_url" target="_blank">{{ props.row.fsContractId }}</jw-link>
        <span v-else>{{ props.row.fsContractId }}</span>
      </template>
      <span v-else>-</span>
    </template>
  </template>
  <!-- e签宝签约状态 -->
  <template v-if="props.slotsName == 'esignStatus'">
    <jw-space v-if="props.row.esignStatus" size="large">
      <jw-tag size="small" :color="eSignTagColor(props.row.esignStatus)">{{ props.row.esignStatus }}</jw-tag>
      <jw-button v-if="props.row.esignStatus == '失败' || props.row.esignStatus == '过期'" size="mini" type="outline" @click="startSigning(props.row)" :loading="data.activeId == props.row.id && data.signLoading">发起签署</jw-button>
    </jw-space>
    <span v-else>-</span>
  </template>
  <!-- 总数量  -->
  <template v-if="props.slotsName == 'totality'">
    <span v-if="props.row?.totality == 0">0</span>
    <span v-else-if="props.row?.totality">{{ props.row?.totality || '-' }}</span>
  </template>
  <!-- 账期  -->
  <template v-if="props.slotsName == 'billPeriod'">
    <span v-if="props.row?.billPeriod || props.row?.billPeriod == 0">{{ props.row?.billPeriod + $t('天') }}</span>
    <template v-else>-</template>
  </template>
</template>
<script setup>
import { reactive } from 'vue';
import { contractService } from '@/api/';
import { Message } from '@arco-design/web-vue';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const emits = defineEmits(['cb']);
import { tools } from '@/utils/tools';
import { huaYingOrdId } from '@/utils/const';
import { useUserStore } from '@/store';
const { userInfo } = useUserStore(); //用户信息
const props = defineProps({
  entity: {
    //对象的entity
    type: Number || String,
    default: undefined
  },
  slotsName: {
    //插槽名称
    type: String,
    default: () => ''
  },
  row: {
    //列表每行数据
    type: Array,
    default: () => {}
  },
  detailKey: {
    //主属性字段
    type: String,
    default: () => ''
  }
});
const data = reactive({
  activeId: null,
  // 合同签署
  signLoading: false,
  colors: { 建议转化: '#37b41a', 建议无效: 'var(--color-text-2)', 待定: 'gold', 待处理: 'orange', '': 'gray' }
});
// e签宝标签颜色
const eSignTagColor = (v) => {
  if (v === '失败') {
    // value==-3
    return 'magenta';
  } else if (v === '未发起') {
    // value==-1
    return 'purple';
  } else if (v === '签署中') {
    // value==-1
    return 'orange';
  } else if (v === '已签署') {
    // value==2
    return 'green';
  } else if (v === '过期') {
    // value==5
    return 'gray';
  } else if (v === '拒签') {
    // value==7
    return 'magenta';
  }
};
//合同发起签署
const startSigning = async (record) => {
  data.activeId = record?.id;
  data.signLoading = true;
  try {
    const json = await contractService.startSigning({ id: record.id });
    if (json.error) {
      Message.error(json.error?.msg || t('操作失败'));
    } else {
      Message.success(t('签署成功'));
      emits('cb'); //回调刷新列表
    }
    data.signLoading = false;
  } catch (e) {
    console.log(e);
    data.signLoading = false;
    Message.error(e.message || e.statusText || t('操作失败'));
  }
};
// 跳转飞书合同详情
const isFeiShuApp = window.h5sdk;
const openFSDetails = (record) => {
  if (!record.fsContractId) {
    Message.warning(t('tips.noFeishu'));
    return;
  }
  if (record.fsContractMultiUrl) {
    const fsContractMultiUrl = JSON.parse(record.fsContractMultiUrl);
    if (isFeiShuApp) {
      //移动端--飞书环境
      window.open(fsContractMultiUrl.sidebar_url);
    } else {
      window.open(fsContractMultiUrl.pc_url);
    }
  }
};
// 主属性跳转
const toDetails = () => {
  emits('cb', props.row);
};
</script>
<style scoped lang="less">
@import './ly-template-slot.less';
</style>
